import { Injectable, Injector } from '@angular/core';
import { map, OperatorFunction } from 'rxjs';

import { AppConf } from '@contact/upgrade';

import { SessionDeprecatedService } from '../auth/session-deprecated.service';
import { NG1_HTTP, NG1_Q } from '../core.provider.ajs';
import { AsObservableRequestBuilder } from './models/asobservable-request-builder';
import { AsPromiseRequestBuilder } from './models/aspromise-request-builder';

export interface HttpDeprecatedResult<T = any> {
  data: T;
}

export function toHttpDeprecatedResult<T>(): OperatorFunction<T, HttpDeprecatedResult<T>> {
  return map(data => ({ data }));
}

/**
 * @deprecated prefer use HttpService
 */
@Injectable({
  providedIn: 'root',
})
export class HttpDeprecatedService {
  private baseUrl: string;

  constructor(
    private readonly injector: Injector,
    private readonly sessionDeprecatedService: SessionDeprecatedService,
    private readonly appConf: AppConf
  ) {
    this.appConf.subscribe(({ restBaseUrl }) => (this.baseUrl = restBaseUrl || ''));
  }

  /**
   * Creates an HTTP request builder which will instanciate an Observable.
   * @returns {AsObservableRequestBuilder}
   * @deprecated prefer use HttpService
   */
  asObservable(): AsObservableRequestBuilder {
    return new AsObservableRequestBuilder(this.injector.get(NG1_HTTP), this.sessionDeprecatedService, this.baseUrl);
  }

  /**
   * Creates an HTTP request builder which will instanciate a Promise.
   * @returns {AsPromiseRequestBuilder}
   * @deprecated prefer use HttpService
   */
  asPromise(): AsPromiseRequestBuilder {
    return new AsPromiseRequestBuilder(this.injector.get(NG1_Q), this.injector.get(NG1_HTTP), this.sessionDeprecatedService, this.baseUrl);
  }
}
